import React from 'react';

const secondsToHMS = (secs) => {
  function zvalue(n) { return (n < 10 ? '0' : '') + n; }
  let sign = secs < 0 ? '-' : '';
  let seconds = Math.abs(secs);
  return sign + Math.floor(zvalue(seconds / 3600 || 0)) + ':'
   + Math.floor(zvalue((seconds % 3600) / 60 || 0)) + ':' + zvalue(seconds % 60);
};

const hmsToSeconds = (tempTime) => {
  let timeValue = tempTime.split(':');
  return timeValue[0] * 3600 + timeValue[1] * 60 + (+timeValue[2] || 0);
};

const convertTo24h = (timeStr) => {
  let time = timeStr.match(/(\d+):(\d+):(\d+) (\w)/);
  let hr = Number(time[1]);
  let mins = Number(time[2]);
  let seconds = Number(time[3]);
  let meridian = time[4].toLowerCase();
  let result;

  if (meridian === 'p' && hr < 12) {
    hr += 12;
  } else if (meridian === 'a' && hr === 12) {
    hr -= 12;
  }
  result = hr + ':' + mins + ':' + seconds;
  return result;
};
const helpers = {
  calculateSbotdTimeLeft: () => {
    const usaTimeZone = new Date().toLocaleString('en-US', { timeZone: 'America/Anchorage' });
    let usaTime = usaTimeZone.split(',');
    let currentTime = usaTime[1];

    let convertedTime = convertTo24h(currentTime);
    let dayEndTime = '22:59:59';
    const endTime = secondsToHMS(hmsToSeconds(dayEndTime) - hmsToSeconds(convertedTime));

    let promotionEnd = endTime.split(':');
    let hrs = promotionEnd[0] + 'hr ';
    let mins = promotionEnd[1] + 'min ';
    let sec = promotionEnd[2] + 'sec';
    let timeLeft = hrs + mins + sec;
    return timeLeft;
  }
};

export default helpers;